module.exports = __webpack_public_path__ + "static/media/report_0002.bb3255e5.pdf";